<template>
  <div>
    <el-form
      v-loading="isLoading"
      :model="account"
      size="small"
    >
      <el-form-item label="Shipper Active">
        <el-radio-group v-model="account.shipper_active">
          <el-radio-button :label="true">
            Active
          </el-radio-button>
          <el-radio-button :label="false">
            Inactive
          </el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="Shipper Channel">
        <el-radio-group v-model="account.shipper_channel">
          <el-radio-button :label="0">
            Stable (Recommended)
          </el-radio-button>
          <el-radio-button :label="1">
            Beta
          </el-radio-button>
          <el-radio-button :label="2">
            Legacy
          </el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="Shipper Manifest Type">
        <el-select
          v-model="account.shipper_manifest_type"
          placeholder="Shipper Manifest Type"
          class="w-100"
          clearable
        >
          <el-option
            label="OSP Handles EDI"
            :value="0"
          />
          <el-option
            label="EDI Enabled (Carrier Direct)"
            :value="1"
          />
          <el-option
            label="EDI Disabled (Not Reccomended)"
            :value="2"
          />
          <el-option
            label="Demo Account (Manifesting Disabled)"
            :value="3"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="Consignment Cost Warning">
        <el-input-number
          v-model="account.shipper_cost_warning"
          placeholder="Shipper Cost Warning"
          controls-position="right"
        />
      </el-form-item>
      <el-form-item label="Domestic Freight Only">
        <el-switch v-model="account.shipper_auonly" />
      </el-form-item>
      <el-form-item label="Enable OpenFreight Plus">
        <el-switch v-model="account.shipper_enable_plus" />
      </el-form-item>
      <el-form-item label="Enable SMS Tracking Notifications">
        <el-switch v-model="account.can_sms" />
      </el-form-item>
      <el-form-item label="Enable Tracking Webhook Exports">
        <el-switch v-model="account.can_send_webhook_events" />
      </el-form-item>
      <el-form-item label="Auto Fill Missing Receiver Details">
        <el-switch v-model="account.shipper_fill_missing_receiver_address_fields" />
      </el-form-item>
      <el-form-item label="Consignment Import Template">
        <el-input
          v-model="account.shipper_polling_filename"
          placeholder="standard.import"
          clearable
        />
      </el-form-item>
      <el-form-item label="PrintNode API Key">
        <el-input
          v-model="account.cloud_print_settings.api_token"
          placeholder=""
          show-password
        />
      </el-form-item>
      <el-form-item style="float: right;">
        <el-button
          type="primary"
          :disabled="isLoading"
          @click.native="saveShipperEdit()"
        >
          Save
        </el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  props: {
    accountId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      account: {
        cloud_print_settings: {
          api_token: ''
        }
      },
      isLoading: false
    }
  },
  created () {
    this.readAccount()
  },
  methods: {
    readAccount () {
      this.isLoading = true
      this.$sdk.account.read(this.accountId, builder => {
        builder.include = ['cloud_print_settings']
      })
        .then(acc => {
          this.account = acc
          if (!this.account.cloud_print_settings) {
            this.account.cloud_print_settings = { api_token: '' }
          }
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    saveShipperEdit () {
      this.isLoading = true
      this.account.update()
        .then(() => this.$message({ message: 'Successfully saved', type: 'success' }))
        .finally(() => {
          this.readAccount()
          this.isLoading = false
        })
    }
  }
}
</script>

<style>

</style>
